<section class="px-6 py-20 sm:px-10">
  <div class="mx-auto max-w-5xl">
    <p class="mb-6">
      <a
        routerLink="/admin"
        class="text-sm text-dusk hover:text-parchment hover:underline"
        >&larr; Back to admin dashboard</a
      >
    </p>

    <div class="mb-8 flex items-end justify-between gap-4">
      <div>
        <span class="mb-4 block text-[0.72rem] font-semibold uppercase tracking-[0.16em] text-gold"
          >Site admin</span
        >
        <h1 class="font-display text-3xl font-semibold text-parchment">Manage users</h1>
      </div>
      <button
        type="button"
        (click)="openCreate()"
        class="inline-flex shrink-0 items-center justify-center rounded-[3px] bg-gradient-to-b from-gold to-gold-dim px-5 py-2.5 text-sm font-bold text-ink transition hover:-translate-y-px"
      >
        + New
      </button>
    </div>

    <form [formGroup]="searchForm" (ngSubmit)="search()" class="mb-6 flex gap-3">
      <input
        formControlName="q"
        type="text"
        placeholder="Filter by email or name…"
        class="flex-1 rounded border border-hairline bg-ink px-4 py-2.5 text-parchment placeholder:text-dusk/60 focus:border-gold focus:outline-none"
      />
      <button
        type="submit"
        class="inline-flex shrink-0 items-center justify-center rounded-[3px] bg-gradient-to-b from-gold to-gold-dim px-5 py-2.5 text-sm font-bold text-ink transition hover:-translate-y-px"
      >
        Search
      </button>
    </form>

    @if (loading()) {
      <p class="text-dusk">Loading…</p>
    } @else if (errorMessage()) {
      <p class="rounded border border-wax/40 bg-wax/10 px-4 py-3 text-sm text-parchment">
        {{ errorMessage() }}
      </p>
    } @else if (items().length === 0) {
      <p class="text-sm text-dusk">No users match.</p>
    } @else {
      <div class="rounded-md border border-hairline bg-panel">
        <ul class="flex flex-col divide-y divide-hairline">
          @for (user of items(); track user.id) {
            <li>
              <button
                type="button"
                (click)="open(user)"
                class="flex w-full items-center justify-between gap-3 px-4 py-3 text-left text-sm transition hover:bg-parchment/[0.04]"
              >
                <span class="flex min-w-0 flex-col">
                  <span class="flex flex-wrap items-center gap-2 text-parchment">
                    {{ user.displayName }}
                    @if (user.siteRole === 'SITE_ADMIN') {
                      <span
                        class="shrink-0 rounded-full border border-dusk px-2 py-0.5 text-[0.6rem] font-semibold uppercase tracking-wide text-dusk"
                        >Site admin</span
                      >
                    }
                    @if (user.plan === 'TIER_1') {
                      <span
                        class="shrink-0 rounded-full border border-gold px-2 py-0.5 text-[0.6rem] font-semibold uppercase tracking-wide text-gold"
                        >Tier 1</span
                      >
                    }
                    @if (user.plan === 'SITE_ADMIN') {
                      <span
                        class="shrink-0 rounded-full border border-gold px-2 py-0.5 text-[0.6rem] font-semibold uppercase tracking-wide text-gold"
                        >No limits</span
                      >
                    }
                  </span>
                  <span class="break-all text-xs text-dusk">{{ user.email }}</span>
                  <span class="text-xs text-dusk">
                    @if (user.lastLoginAt) {
                      Last login {{ user.lastLoginAt | date: 'MMM d, y, h:mm a' }}
                    } @else {
                      Never logged in
                    }
                  </span>
                </span>
                <span class="shrink-0 text-right text-xs text-dusk">
                  <span class="block">{{ user.ownedCount }} owned</span>
                  <span class="block">{{ user.joinedCount }} joined</span>
                </span>
              </button>
            </li>
          }
        </ul>
      </div>

      <div class="mt-4 flex items-center justify-between text-sm">
        <button
          type="button"
          (click)="goToPage(page() - 1)"
          [disabled]="page() <= 1"
          class="text-dusk hover:text-parchment disabled:cursor-not-allowed disabled:opacity-40"
        >
          &larr; Previous
        </button>
        <span class="text-xs uppercase tracking-wide text-dusk">
          Page {{ page() }} of {{ totalPages() }} ({{ total() }} total)
        </span>
        <button
          type="button"
          (click)="goToPage(page() + 1)"
          [disabled]="page() >= totalPages()"
          class="text-dusk hover:text-parchment disabled:cursor-not-allowed disabled:opacity-40"
        >
          Next &rarr;
        </button>
      </div>
    }

    @if (editingUserId(); as id) {
      <app-user-modal
        [userId]="id"
        (closed)="onModalClosed()"
        (changed)="onModalChanged()"
      />
    }
    @if (isCreating()) {
      <app-user-modal (closed)="onModalClosed()" (changed)="onModalChanged()" />
    }
  </div>
</section>
